import React, { useContext } from 'react';
import { BitButton } from '../BitButton';
import { TutorialPopoverContent } from './styles';
import { TutorialsContext } from '../../contexts/TutorialsContext';
import { X } from '@phosphor-icons/react';
import { TeamsFxContext } from '../../Context';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogSurface,
  FluentProvider,
} from '@fluentui/react-components';

interface TutorialPopoverProps {
  appId: string;
  scope: string;
  dimissPopover: () => void;
  title: string;
  isVisible?: boolean;
}

export const TutorialPopover = ({
  scope,
  appId,
  dimissPopover,
  title,
  isVisible,
}: TutorialPopoverProps) => {
  const { teamsUserCredential } = useContext(TeamsFxContext);

  const { runTutorial, switchFirstRun } = useContext(TutorialsContext);

  function neverShowAgain() {
    dimissPopover();
    teamsUserCredential && switchFirstRun(appId, teamsUserCredential);
  }

  return (
    <FluentProvider>
      <Dialog open={isVisible}>
        <DialogSurface>
          <DialogContent>
            <TutorialPopoverContent>
              <X size={20} onClick={() => dimissPopover()} />
              <p>Do you want to take a guided tour through {title}?</p>
            </TutorialPopoverContent>
          </DialogContent>
          <DialogActions
            fluid
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <BitButton
              label="Start now"
              action={() => {
                runTutorial(scope);
                dimissPopover();
              }}
            />
            <BitButton
              label="Don't show again"
              variant="secondary"
              action={() => neverShowAgain()}
            />
          </DialogActions>
        </DialogSurface>
      </Dialog>
    </FluentProvider>
  );
};
